import $ from "jquery";

class StickyBanner {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.item = self.elem.querySelector('[data-sticky-banner-item]');
        self.trigger = self.elem.querySelector('[data-sticky-banner-trigger]');
        // self.holdTrigger = document.querySelector('[data-sticky-banner-hold-trigger]');
    }

    init() {
        let self = this;

        self.stickyNav();
    }

    stickyNav() {
        let self = this;
        let nextElem = self.elem.nextElementSibling;
        let holdTrigger = self.getNextAttr(nextElem);

        document.addEventListener('scroll', (e) => {
            if (window.scrollY > self.trigger.offsetTop) {
                self.item.classList.add('is-sticky');
                self.elem.classList.add('is-active');
            } else {
                self.item.classList.remove('is-sticky');
                self.elem.classList.remove('is-active');
            }

            let bounding = holdTrigger.getBoundingClientRect();
            let calc = self.item.offsetHeight - bounding.y;
            let scrollValue = '-' + calc + 'px';

            if (self.item.offsetHeight > bounding.y) {
                self.item.style.marginTop = scrollValue;
            } else {
                self.item.style.marginTop = 0;
            }
        });
    }

    getNextAttr(elem) {
        let self = this;
        let nextElem = elem;

        if (elem.hasAttribute('data-sticky-banner-hold-trigger')) {
            nextElem = elem;
        } else {
            nextElem = self.getNextAttr(elem.nextElementSibling);
        }

        return nextElem;
    }
}

export default StickyBanner;
